"use client";
import React__default, { useMemo } from 'react';
import { header, headerContent, headerText } from './styles.js';
import { Box } from '../../../Box/Box.web.js';
import { renderComponentOrElement } from '../../helpers/component.js';
import { spacing } from '../../../constants/spacing.js';

var ListItemsHeader = /*#__PURE__*/React__default.forwardRef(function ListItemsHeader(_ref, ref) {
  var disableBorders = _ref.disableBorders,
    icon = _ref.icon,
    title = _ref.title,
    description = _ref.description,
    color = _ref.color,
    size = _ref.size;
  var iconElement = useMemo(function () {
    return icon && renderComponentOrElement(icon, {
      ml: 0,
      mr: spacing.xxs,
      'aria-hidden': true
    });
  }, [icon]);
  return /*#__PURE__*/React__default.createElement(header, {
    $disableBorders: disableBorders,
    ref: ref
  }, iconElement && /*#__PURE__*/React__default.createElement(headerContent, {
    color: color
  }, iconElement), /*#__PURE__*/React__default.createElement(Box, {
    overflow: "hidden",
    display: "flex",
    flexDirection: description ? 'column' : 'row',
    gap: spacing.xxxxs
  }, /*#__PURE__*/React__default.createElement(headerContent, {
    color: color
  }, /*#__PURE__*/React__default.createElement(headerText, {
    color: color,
    $size: size,
    $isTight: !!description,
    $isTitle: true
  }, title)), description && /*#__PURE__*/React__default.createElement(headerContent, {
    color: color
  }, /*#__PURE__*/React__default.createElement(headerText, {
    color: color,
    $size: size,
    $isTight: true
  }, description))));
});

export { ListItemsHeader };
